var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['sw-btn',
    ("sw-btn--" + _vm.theme),
    { 'sw-btn--disabled': _vm.disabled },
    { 'sw-btn--default': _vm.asDefault } ],attrs:{"disabled":_vm.disabled,"type":"button"}},[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }